export default __webpack_public_path__ + "static/vendor-cta-ffbefc8fe26d7cd0f7eb4de667f2e8a1.webp";